const setIsSearch = (state, isSearch) => {
  state.isSearch = isSearch
};

const setTextSearch = (state, textSearch) => {
  state.textSearch =  textSearch
};

const setIsSearchAdvanced = (state, isSearchAdvanced) => {
  state.isSearchAdvanced =  isSearchAdvanced
};

export default {
  setIsSearch,
  setTextSearch,
  setIsSearchAdvanced,
};





// WEBPACK FOOTER //
// ./src/store/modules/search/mutations.js